import { type CancellationProtection } from "@clipboard-health/contract-backend-main";
import { Button } from "@src/appV2/redesign/components/Button";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";
import { useModalState } from "@src/appV2/redesign/system/ui-components";

import { CancellationProtectionTermsBottomSheet } from "./CancellationProtectionTermsBottomSheet";
import { SegmentedText } from "./SegmentedText";
import { getCancellationProtectionPolicyDescription } from "./utils/getCancellationProtectionDescription";

interface ShiftCancellationProtectionCardProps {
  formattedPayAmount?: string;
  cancellationProtection: CancellationProtection;
  workplaceName: string;
}

export function ShiftCancellationProtectionCard(props: ShiftCancellationProtectionCardProps) {
  const { formattedPayAmount, cancellationProtection, workplaceName } = props;
  const termsModalState = useModalState();

  if (!cancellationProtection.enabled) {
    return (
      <ShiftBottomSheetBookabilityCriteriaCard
        intent="limited"
        title="No Cancellation Protection"
        description="You will not receive any payout from the workplace if they cancel your shift or send you home early."
        illustrationType="parachute-orange"
      />
    );
  }

  const { cancellationProtectionWindowInHours, isSentHomeProtected } = cancellationProtection;

  const descriptionSegments = getCancellationProtectionPolicyDescription(
    formattedPayAmount,
    cancellationProtectionWindowInHours,
    isSentHomeProtected
  );

  return (
    <>
      <ShiftBottomSheetBookabilityCriteriaCard
        title="Cancellation Protection"
        description={
          <SegmentedText
            segments={descriptionSegments}
            sx={{ color: (theme) => theme.palette.text.secondary }}
          />
        }
        illustrationType="parachute-blue"
        footer={
          <Button
            fullWidth
            variant="outlined"
            size="medium"
            onClick={() => termsModalState.openModal()}
          >
            View terms
          </Button>
        }
      />
      <CancellationProtectionTermsBottomSheet
        modalState={termsModalState}
        cancellationProtectionWindowInHours={cancellationProtectionWindowInHours}
        isSentHomeProtected={isSentHomeProtected}
        workplaceName={workplaceName}
      />
    </>
  );
}
